import { withContent } from '@bubbletea/core';
import { Pagination } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import uniqueId from 'lodash/uniqueId';
import Title from '../../UI/Title';
import { IContent } from '../../../types';

import { ContentWrapper, Caption, KeyFeaturesWrapper, DesktopContainer, MobileTabletContainer } from './styles';
import KeyFeature from '../../Blocks/KeyFeature';
import { IAdobeClickEvent } from '../../../types/tracking';
import sendEvent from '../../../utils/sendEvent';

interface IKeyFeaturesProps {
  context: IContent;
}

const KeyFeatures = ({ context }: IKeyFeaturesProps) => {
  const { googlesheet } = context;
  const { features } = googlesheet;
  const { caption, featuresItems, title } = features;

  const impressionEventDetails: IAdobeClickEvent = {
    location: 'key features',
    category: 'scroll',
    locationPosition: process.env['REACT_APP_PAGE_TYPE'] === 'subscriber' ? 5 : 2,
    action: 'visible',
  };

  return (
    <ContentWrapper
      id={'features'}
      whileInView={'sendevent'}
      onAnimationStart={() => sendEvent(impressionEventDetails, 'impressionevent')}
      viewport={{ once: true }}
    >
      <div className="section-wrapper">
        <Title textAlign="center" uppercase>
          {title}
        </Title>
        <DesktopContainer>
          <KeyFeaturesWrapper>
            {featuresItems.map((feature, index) => (
              <KeyFeature feature={feature} key={`key_feature_${uniqueId()}`} index={index} />
            ))}
          </KeyFeaturesWrapper>
        </DesktopContainer>
        <MobileTabletContainer>
          <Swiper
            slidesPerView={1.5}
            centeredSlides
            modules={[Pagination]}
            pagination={{
              clickable: true,
            }}
            breakpoints={{
              640: {
                slidesPerView: 2,
              },
            }}
            loop
          >
            {featuresItems.map((feature) => (
              <SwiperSlide key={`key_feature_${uniqueId()}`}>
                <KeyFeature feature={feature} />
              </SwiperSlide>
            ))}
          </Swiper>
        </MobileTabletContainer>
        <Caption dangerouslySetInnerHTML={{ __html: caption as string }} />
      </div>
    </ContentWrapper>
  );
};

export default withContent(KeyFeatures);
